import React, { useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/contexts/ThemeContext";
import ThemeToggle from "@/components/ThemeToggle";
import LanguageSelector from "@/components/LanguageSelector";
import PageTransition from "@/components/PageTransition";
import SiteFooter from "@/components/SiteFooter";

const LOGO_ICON = "https://customer-assets.emergentagent.com/job_d04ef3c1-d7de-40d8-b6b3-0d99244d2801/artifacts/0hpd8r65_icon_markremoved%20backround.png";

export default function PageLayout({ children }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <PageTransition>
      <div className="min-h-screen bg-[var(--qn-background)] flex flex-col">
        <motion.nav
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="fixed top-0 left-0 right-0 z-50 glass border-b border-[var(--qn-border)]"
        >
          <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <motion.img src={LOGO_ICON} alt="QNNEAL" className="h-10 w-10 logo-spin" whileHover={{ scale: 1.05 }} />
              <span className="font-outfit font-bold text-2xl tracking-tight">QNNEAL</span>
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className="text-sm font-medium text-[var(--qn-foreground-muted)] hover:text-[var(--qn-foreground)] transition-colors">Home</Link>
              <Link to="/company" className="text-sm font-medium text-[var(--qn-foreground-muted)] hover:text-[var(--qn-foreground)] transition-colors">Company</Link>
              <Link to="/blog" className="text-sm font-medium text-[var(--qn-foreground-muted)] hover:text-[var(--qn-foreground)] transition-colors">Blog</Link>
              <Link to="/careers" className="text-sm font-medium text-[var(--qn-foreground-muted)] hover:text-[var(--qn-foreground)] transition-colors">Careers</Link>
              <Link to="/contact" className="text-sm font-medium text-[var(--qn-foreground-muted)] hover:text-[var(--qn-foreground)] transition-colors">Contact</Link>
            </div>
            <div className="flex items-center gap-3">
              <LanguageSelector />
              <ThemeToggle />
              <Button variant="ghost" className="text-sm" onClick={() => navigate("/login")}>Log In</Button>
              <Button className="btn-primary text-sm" onClick={() => navigate("/login")}>Get Started</Button>
            </div>
          </div>
        </motion.nav>

        <main className="flex-1 pt-24">
          {children}
        </main>

        <SiteFooter />
      </div>
    </PageTransition>
  );
}
